import * as z from "zod";

export const ShopperAgentIMessageConfigSchema = z.object({
  enabled: z.boolean().optional(),
});

export type ShopperAgentIMessageConfig = z.infer<
  typeof ShopperAgentIMessageConfigSchema
>;
